var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24268 8.42424H25.6972L22.7881 18.1212H8.24268",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18201 25.8788C9.18201 26.3976 8.76143 26.8182 8.24262 26.8182C7.7238 26.8182 7.30322 26.3976 7.30322 25.8788C7.30322 25.36 7.7238 24.9394 8.24262 24.9394C8.76143 24.9394 9.18201 25.36 9.18201 25.8788Z",
    fill: "#020025",
    stroke: "#257FFC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6971 25.8788C24.6971 26.3976 24.2766 26.8182 23.7578 26.8182C23.2389 26.8182 22.8184 26.3976 22.8184 25.8788C22.8184 25.36 23.2389 24.9394 23.7578 24.9394C24.2766 24.9394 24.6971 25.36 24.6971 25.8788Z",
    fill: "#020025",
    stroke: "#257FFC",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 5.51515L8.24259 8.42424V18.1212L6.30319 22H26.6668",
    stroke: "#257FFC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.5f33fbe4.svg";
export { ForwardRef as ReactComponent };